const MODEL_3D_CONST = {
    PICK_TEXTURE: 'PICK_TEXTURE',
    LIST_PART_NAME: 'LIST_PART_NAME',
};

export default MODEL_3D_CONST;
